export var AdminNoticeCategory;
(function (AdminNoticeCategory) {
    AdminNoticeCategory["NOTICE"] = "NOTICE";
    AdminNoticeCategory["UPDATE_NOTE"] = "UPDATE_NOTE";
})(AdminNoticeCategory || (AdminNoticeCategory = {}));
